import { render, staticRenderFns } from "./MemberDocumentList.vue?vue&type=template&id=439b7db7"
import script from "./MemberDocumentList.vue?vue&type=script&lang=js"
export * from "./MemberDocumentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports